import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getBusinessProcesses(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES,
		options
	)
}

function _getBusinessProcessesMainInfo(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_MAIN_INFO,
		options
	)
}

function _getBusinessProcessesPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_POPUP,
		options
	)
}

function _getBusinessProcessesPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_PREVIEW,
		options
	)
}

function _getBusinessProcess(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS,
		options
	)
}

function _createBusinessProcess(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS,
		options
	)
}

function _patchBusinessProcess(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS,
		options
	)
}

function _putBusinessProcess(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS,
		options
	)
}

function _deleteBusinessProcess(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].DELETE_BUSINESS_PROCESS,
		options
	)
}
function _createBusinessProcessCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_CROP,
		options
	)
}
function _patchBusinessProcessCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_CROP,
		options
	)
}

function _putBusinessProcessCrop(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_CROP,
		options
	)
}

function _multiSetCulture(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].MULTI_SET_CULTURE,
		options
	)
}

function _getBusinessProcessesActiveStages(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGES,
		options
	)
}
function _getBusinessProcessesActiveStage(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE,
		options
	)
}
function _getBusinessProcessesActiveStagePopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_POPUP,
		options
	)
}
function _getBusinessProcessesActiveStagePreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_PREVIEW,
		options
	)
}

function _getBusinessProcessesFinanceByCategories(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_CATEGORIES,
		options
	)
}

function _getBusinessProcessesFinanceByDestination(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_DESTINATION,
		options
	)
}

function _getBusinessProcessesFinanceByWorkTypes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_WORK_TYPES,
		options
	)
}

function _createBusinessProcessUniversal(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_UNIVERSAL,
		options
	)
}

function _patchBusinessProcessUniversal(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_UNIVERSAL,
		options
	)
}

function _putBusinessProcessUniversal(options = {}) {
	return _apiRequestWrap(
		ModulesMap.BUSINESS_PROCESSES,
		ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_UNIVERSAL,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES]: _getBusinessProcesses,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_MAIN_INFO]: _getBusinessProcessesMainInfo,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_POPUP]:
		_getBusinessProcessesPopup,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS_PREVIEW]:
		_getBusinessProcessesPreview,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESS]: _getBusinessProcess,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS]: _createBusinessProcess,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS]: _patchBusinessProcess,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS]: _putBusinessProcess,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].DELETE_BUSINESS_PROCESS]: _deleteBusinessProcess,

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_CROP]:
		_createBusinessProcessCrop,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_CROP]:
		_patchBusinessProcessCrop,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_CROP]:
		_putBusinessProcessCrop,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].MULTI_SET_CULTURE]: _multiSetCulture,

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGES]: _getBusinessProcessesActiveStages,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE]: _getBusinessProcessesActiveStage,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_POPUP]: _getBusinessProcessesActiveStagePopup,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_ACTIVE_STAGE_PREVIEW]: _getBusinessProcessesActiveStagePreview,

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_CATEGORIES]: _getBusinessProcessesFinanceByCategories,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_DESTINATION]: _getBusinessProcessesFinanceByDestination,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].GET_BUSINESS_PROCESSES_FINANCE_BY_WORK_TYPES]: _getBusinessProcessesFinanceByWorkTypes,

	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].CREATE_BUSINESS_PROCESS_UNIVERSAL]: _createBusinessProcessUniversal,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PATCH_BUSINESS_PROCESS_UNIVERSAL]: _patchBusinessProcessUniversal,
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES].PUT_BUSINESS_PROCESS_UNIVERSAL]: _putBusinessProcessUniversal,
}
